module.exports = __webpack_public_path__ + "static/media/icon-circle.48cffa68.svg";